/**
 * Get full image URL from relative path
 * @param {string} imagePath - Relative image path from API
 * @returns {string} Full image URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return 'https://via.placeholder.com/300x300?text=No+Image';
  }
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Get base URL from environment or default
  // Use localhost:8000 directly for static files (not the /api endpoint)
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000';
  
  // Ensure the path starts with /
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  
  const fullUrl = `${baseUrl}${normalizedPath}`;
  console.log('Image URL:', fullUrl); // Debug log
  
  return fullUrl;
};

/**
 * Handle image loading error
 * @param {React.SyntheticEvent} event - Image error event
 * @param {string} fallbackUrl - Fallback image URL
 */
export const handleImageError = (event, fallbackUrl = 'https://via.placeholder.com/300x300?text=No+Image') => {
  console.error('Image failed to load:', event.target.src);
  event.target.src = fallbackUrl;
  event.target.onerror = null; // Prevent infinite loop
};